




import { Component, Vue } from 'vue-property-decorator';
import Intro from '@/components/Intro.vue';

// TODO: Remove this component. Leave for now as an example.
@Component({
	components: {
		Intro,
	},
})
export default class Contact extends Vue {}
